<template>
  <div class="card-header border-bottom pt-1 pb-1 header_txt">
    <h4 class="card-title">Profile</h4>
  </div>
  <div class="card-body mt-2">
    <vForm @submit="onSubmit" :validation-schema="schema">
      <div class="row">
        <div class="col-md-6 offset-md-3 col-12">
          <div class="row">

            <div class="col-12">
              <label for="">Name</label>
              <div class="mb-1">
                <vField
                    v-model="formData.full_name"
                    type="text"
                    name="full_name"
                    class="form-control add-credit-card-mask"
                    placeholder="Full Name"
                />
                <ErrorMessage name="full_name" class="invalid-feedback d-block qcont"/>
              </div>
            </div>

            <div class="col-12">
              <label for="">Mobile No</label>
              <div class="mb-1">
                <input type="text" id="legal-name" class="form-control" v-model="formData.mobile_no"
                       placeholder="Mobile No"/>
              </div>
            </div>

            <div class="col-12">
              <label for="">Date Of Birth</label>
              <div class="mb-1">
                <input type="date" id="birthday" class="form-control" v-model="formData.birthday"
                       placeholder="Birthday"/>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-1">
                <label for="">Gender</label>
                <select class="form-control" id="gender" v-model="formData.gender">
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="others">Others</option>
                </select>
              </div>
            </div>

            <div class="col-12" v-if="false">
              <div class="mb-1">
                <label for="">Contact Group</label>
                <AsyncSelect
                    placeholder="Select"
                    v-model="formData.contact_group"
                    :api-service="fetchNoteMasterList"
                    :additional-query="{note_type: 'contact_group'}"
                    label="name"
                    :reduce="option => option"
                    class="mb-1"
                />
              </div>
            </div>

            <div class="col-12">
              <div class="d-flex align-items-center justify-content-between filter-label">
                <label for="colFormLabel" class="col-form-label">Referrer: </label>
                <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
              </div>
              <div class="mb-1">
                <AsyncSelect
                    placeholder="Select Referrer"
                    v-model="formData.contact_owner"
                    :api-service="fetchContactProfiles"
                    :additional-query="{ with_mobile: 1, roles: 'employee' }"
                    :format-label="formatPatientLabel"
                />
              </div>
            </div>

            <div class="col-12" v-if="false">
              <label class="col-form-label">Incentive Level</label>
              <div class="mb-1">
                <v-select
                    placeholder="Select Level"
                    v-model="selectedIncentive"
                    :options="incentiveSetupList"
                    label="name"
                />
              </div>
            </div>

            <div class="col-12">
              <label for="">NID</label>
              <div class="mb-1">
                <input type="text" id="nid" class="form-control" v-model="formData.nid"
                       placeholder="NID"/>
              </div>
            </div>

            <div class="col-12">
              <label for="">TIN No</label>
              <div class="mb-1">
                <input type="text" id="tin_no" class="form-control" v-model="formData.tin_no"
                       placeholder="TIN No."/>
              </div>
            </div>

            <div class="col-12">
              <label for="">Father Name</label>
              <div class="mb-1">
                <input type="text" id="father-name" class="form-control" v-model="formData.father_name"
                       placeholder="Father Name"/>
              </div>
            </div>

            <div class="col-12">
              <label for="">Mother Name</label>
              <div class="mb-1">
                <input type="text" id="mother-name" class="form-control" v-model="formData.mother_name"
                       placeholder="Mother Name"/>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-1">
                <label for="">Status</label>
                <v-select
                    placeholder="Select Status"
                    v-model="formData.status"
                    :options="status"
                    :reduce="name => name.value"
                    label="name"
                />
              </div>
            </div>
            <div class="col-12">
              <table class="table w-100">
                <thead>
                <tr>
                  <th>Role</th>
                  <th>Serial No</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(companyRole, index) in formData.company_roles_data">
                  <td class="p-1 w-50">
                    <v-select
                        placeholder="Select Role"
                        v-model="companyRole.id"
                        :options="companyRules"
                        label="name"
                        :reduce="name => name.id"
                    />
                  </td>
                  <td class="p-1 w-25"><input type="text" class="form-control" v-model="companyRole.serial_no"/></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-6 offset-sm-3">
              <button type="submit" class="btn btn-primary me-1" :disabled="isSubmitting">Submit</button>
              <button type="reset" class="btn btn-outline-secondary" @click="isSubmitting = false">Reset</button>
            </div>

          </div>
        </div>
      </div>
    </vForm>
  </div>

  <ContactDropdownFilter
      v-if="store.state.isModalOpenThree"
      @onSearchContact="onSearchContact"
      type="employee"
  />
</template>

<script setup>
import {onMounted, ref, watch, defineProps, defineEmits, computed} from "vue";
import handleChartAccount from '@/services/modules/chartAccount'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleHospital from '@/services/modules/hospital';
import handleContact from "@/services/modules/contact";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import {useRoute} from "vue-router";
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import {useStore} from "vuex";

const props = defineProps({
  companyRules: {
    type: Array,
    default: []
  },
  formData: {
    type: Object
  },
  status: {
    type: Array,
    default: []
  },
  submitSuccess: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['storeContact'])

const onSubmit = () => {
  isSubmitting.value = true
  emit('storeContact', formData.value)
}

watch(() => props.submitSuccess, (val) => {
  if (val) isSubmitting.value = false
})

const {fetchHome} = handleChartAccount()
const { fetchNoteMasterList, fetchIncentiveSetupList } = handleHospital();
const {fetchContactProfiles} = handleContact()
const {formatPatientLabel} = useAsyncDropdownHelper();
const route = useRoute();
const store = useStore();

const schema = {
  full_name: 'required'
}
const isSubmitting = ref(false)
let incentiveSetupList = ref([])
const formData = ref({
  full_name: '',
  mobile_no: '',
  designation: '',
  company_name: '',
  department: '',
  birthday: '',
  religion: '',
  contact_group: '',
  contact_owner: '',
  incentive_setup_id: '',
  url: '',
  gender: '',
  location: '',
  nid: '',
  tin_no: '',
  father_name: '',
  mother_name: '',
  status: 'active',
  company_rules: [],
  company_roles_data: []
})

const onSearchContact = (contact) => {
  formData.value.contact_owner = contact
}

const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

watch(() => [props.formData, props.companyRules], () => {
  formDataSet();
});

const selectedIncentive = computed({
  get() {
    if (!incentiveSetupList.value.length) return null;
    return incentiveSetupList.value.find(
        item => item.id == formData.value.incentive_setup_id
    ) || null
  },
  set(value) {
    formData.value.incentive_setup_id = value ? value.id : null
  }
})

const formDataSet = () => {
  if (props.formData && props.formData.full_name) {
    formData.value = props.formData
    formData.value.company_rules = props.formData.company_roles_data.map(role => parseInt(role.id));
  }
  if (props.companyRules.length === 1 && !props.formData.company_roles_data && !formData.value.company_roles_data.length) {
    formData.value.company_rules = [props.companyRules[0].id]
    formData.value.company_roles_data.push({
      is_new: false,
      id: props.companyRules[0].id,
      label: props.companyRules[0].name,
      serial_no: '',
      status: 'active',
    })
  }
}

const getIncentiveSetupList = async () => {
  let query = `?company_id=${route.params.companyId}`;
  query += '&is_all=true&incentive_type=level'
  incentiveSetupList.value = []

  await fetchIncentiveSetupList(query).then(res => {
    if (!res.status){
      return
    }
    incentiveSetupList.value = res.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
  })
}

onMounted(() => {
  formDataSet()
  getIncentiveSetupList()
})
</script>

<style scoped>

</style>
